export default __webpack_public_path__ + "static/media/wegovy-pencap-replace.3d857e24.mp4";